import script from "./GridLegalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridLegalComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridLegalComponent.vue?vue&type=style&index=0&id=324c279c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324c279c"]])

export default __exports__